export const organizationChartTranslation = {
  actions: {
    createSimulation: 'Nowa symulacja',
    goToManageStructures: 'Przejdź do zarządzania strukturami',
  },
  buttons: {
    search: 'Wyszukaj węzeł',
  },
  currentStructure: {
    organizational: 'Aktualna struktura organizacyjna',
    personal: 'Aktualna struktura personalna',
  },
  emptyState: {
    noSimulationSelected: {
      description:
        'Wybierz symulację w zakładce „Zarządzaj strukturami”, aby zobaczyć ją na drzewie.',
      title: 'Nie wybrano symulacji',
    },
    unavailable: {
      chart: 'Widok drzewa jest chwilowo niedostępny. Spróbuj ponownie za chwilę.',
      management: 'Zarządzanie symulacjami jest chwilowo niedostępne. Spróbuj ponownie za chwilę.',
      modal: 'Okno tworzenia symulacji jest chwilowo niedostępne.',
      nested: 'Widok zagnieżdżony jest chwilowo niedostępny. Spróbuj ponownie za chwilę.',
    },
  },
  header: {
    subtitle: {
      current: 'Aktualna struktura organizacji — podgląd tylko do odczytu.',
      simulations: 'Twórz i edytuj symulacje struktury bez wpływu na dane produkcyjne.',
    },
  },
  manageStructures: {
    description: 'Przejdź do zakładki "Zarządzaj strukturami" aby wyświetlić i wybrać strukturę.',
    selectStructure: 'Wybierz strukturę',
    title: 'Zarządzaj strukturami',
  },
  simulationBadge: 'Symulacja',
  structureType: {
    organizational: 'Organizacyjna',
    personal: 'Personalna',
  },
  tabs: {
    currentStructures: 'Aktualne struktury',
    manageStructures: 'Zarządzaj strukturami',
    nestedStructure: 'Struktura zagnieżdżona',
    simulationStructures: 'Symulacje struktury',
    treeStructure: 'Struktura drzewiasta',
  },
};
